import script from "./InventPanorama.vue?vue&type=script&setup=true&lang=js"
export * from "./InventPanorama.vue?vue&type=script&setup=true&lang=js"

import "./InventPanorama.vue?vue&type=style&index=0&id=184e95be&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-184e95be"]])

export default __exports__